<dx-box #workflowVendorEditBox height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header">
            Manage AAP Workflow Vendor Edit
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
            <i
                class="far fa-window-restore launch-page-link dx-theme-accent-as-text-color"
                title="Open page in new window"
                (click)="openPageInWindow()"
            ></i>
        </h2>
    </dxi-item>

    <dxi-item [ratio]="1" class="cc-white-background box-grid-container">
        <dx-box width="100%" height="100%" direction="col" class="box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="row-container">
                        <div *ngIf="!selectedContext" class="field-component-container padding-right">
                            <div class="field-label">Community</div>
                            <div class="field-component">
                                <app-multi-column-selector
                                    [name]="'Community'"
                                    [gridSource]="communityList"
                                    [boxValue]="communityGridBoxValue"
                                    [disabled]="!!selectedContext?.communityId"
                                    [valueExpr]="'communityId'"
                                    [displayExpr]="'communityName'"
                                    [columnDef]="communityColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [showClearButton]="true"
                                    [navigateToCommunity]="true"
                                    [placeholder]="'All Communities...'"
                                    [showHeaderFilters]="true"
                                    (gridSelectionEvent)="onCommunitySelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </div>
                        <div class="short-field-component-container padding-right">
                            <div class="padding-right">Lite Mode</div>
                            <div>
                                <dx-switch
                                    class="field-switch"
                                    [(value)]="isLiteMode"
                                    (onValueChanged)="onLiteModeValueChange()"
                                ></dx-switch>
                            </div>
                        </div>
                        <div class="field-component-container padding-right">
                            <dx-button
                                type="default"
                                text="Refresh"
                                [icon]="iconRefresh"
                                (onClick)="onRefreshClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        *ngIf="!!gridSource"
                        [stateConfig]="{ storageKey: 'MANAGE_WORKFLOW_VENDOR_EDIT', storeGroupings: true }"
                        [dataSource]="gridSource"
                    >
                        <dx-data-grid
                            #vendorEditGrid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            [dataSource]="gridSource"
                        >
                            <ng-container *ngIf="isInternalUser">
                                <dxi-column
                                    type="buttons"
                                    caption="Action"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    alignment="center"
                                    [width]="110"
                                    [visibleIndex]="0"
                                    [showInColumnChooser]="false"
                                >
                                    <dxi-button template="template">
                                        <div *dxTemplate="let row of 'template'">
                                            <app-grid-actions-menu
                                                [actionMenuItems]="actionMenuItems"
                                                [record]="row.data"
                                                [rowIndex]="row.rowIndex"
                                                (onActionClick)="onActionClick($event)"
                                            ></app-grid-actions-menu>
                                        </div>
                                    </dxi-button>
                                </dxi-column>
                            </ng-container>
                            <dxi-column
                                dataField="managementCompanyDisplayText"
                                caption="Management Company"
                                dataType="string"
                                [visibleIndex]="1"
                            ></dxi-column>
                            <dxi-column
                                dataField="location"
                                caption="Location"
                                dataType="string"
                                [visibleIndex]="2"
                            ></dxi-column>
                            <dxi-column
                                dataField="community"
                                caption="Community"
                                dataType="string"
                                cellTemplate="communityCellTemplate"
                                [visibleIndex]="3"
                            ></dxi-column>
                            <dxi-column
                                dataField="workflowId"
                                caption="Workflow Id"
                                dataType="string"
                                [visibleIndex]="4"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceNumber"
                                caption="Invoice#"
                                dataType="string"
                                [visibleIndex]="5"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceDate"
                                caption="Invoice Date"
                                dataType="date"
                                [format]="dateFormat"
                                [visibleIndex]="6"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceAmount"
                                caption="Invoice Amount"
                                dataType="number"
                                [format]="currencyFormat"
                                [visibleIndex]="7"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="workflowStatus"
                                caption="Workflow Status"
                                dataType="string"
                                cellTemplate="workflowStatusCellTemplate"
                                [visibleIndex]="8"
                            ></dxi-column>
                            <dxi-column
                                dataField="payee"
                                caption="Vendor / Payee"
                                dataType="string"
                                [visibleIndex]="9"
                            ></dxi-column>
                            <dxi-column
                                dataField="invoiceStatus"
                                caption="Invoice Status"
                                dataType="string"
                                [visibleIndex]="10"
                            ></dxi-column>
                            <dxi-column
                                caption="Invoice"
                                cellTemplate="invoiceFileCellTemplate"
                                alignment="center"
                                [visibleIndex]="11"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalLogs"
                                caption="History"
                                cellTemplate="historyCellTemplate"
                                headerCellTemplate="lockHeaderCellTemplate"
                                alignment="center"
                                [visibleIndex]="12"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalNotes"
                                dataField="hasNotes"
                                dataType="boolean"
                                caption="Notes"
                                cellTemplate="notesCellTemplate"
                                headerCellTemplate="lockHeaderCellTemplate"
                                alignment="center"
                                [visibleIndex]="13"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                caption="Board History"
                                cellTemplate="boardHistoryCellTemplate"
                                alignment="center"
                                [visibleIndex]="14"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                caption="Board Notes"
                                cellTemplate="boardNotesCellTemplate"
                                alignment="center"
                                [visibleIndex]="15"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="communityTerminationDate"
                                caption="Association Termination Date"
                                dataType="date"
                                [format]="dateFormat"
                                [visibleIndex]="16"
                            ></dxi-column>

                            <dxi-column
                                caption="Dashboard Responsible"
                                dataType="string"
                                dataField="responsibleUsers"
                                cellTemplate="responsibleTemplate"
                                headerCellTemplate="lockHeaderCellTemplate"
                                [visibleIndex]="17"
                                [visible]="!isLiteMode && isInternalUser"
                                [showInColumnChooser]="!isLiteMode"
                            >
                                <dxo-header-filter [dataSource]="uniqueResponsibleUsers"></dxo-header-filter>
                            </dxi-column>

                            <ng-container *ngIf="isInternalUser">
                                <dxi-column
                                    dataField="dashboardStatus"
                                    caption="Dashboard Status"
                                    dataType="string"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    [visibleIndex]="18"
                                ></dxi-column>
                            </ng-container>
                            <dxi-column
                                dataField="dueDate"
                                caption="Due Date"
                                dataType="date"
                                [format]="dateFormat"
                                [visibleIndex]="19"
                            ></dxi-column>
                            <dxi-column
                                dataField="eft"
                                caption="EFT"
                                dataType="boolean"
                                cellTemplate="eftCellTemplate"
                                [visibleIndex]="20"
                            ></dxi-column>
                            <dxi-column
                                dataField="specialHandling"
                                caption="Special Handling"
                                dataType="string"
                                [visibleIndex]="21"
                            ></dxi-column>
                            <dxi-column
                                dataField="workflowStartDate"
                                caption="Workflow Start Date"
                                dataType="date"
                                [format]="dateFormat"
                                [visibleIndex]="22"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'communityCellTemplate'">
                                <app-property-community-link
                                    *ngIf="row.data.community"
                                    [communityId]="row.data.communityId"
                                    [displayText]="row.value"
                                ></app-property-community-link>
                            </div>

                            <div *dxTemplate="let a of 'historyCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onWorkflowHistoryClick(a.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'notesCellTemplate'">
                                <div *ngIf="d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content cc-icon-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onWorkflowNotesClick(d.data)"
                                    ></i>
                                </div>

                                <div *ngIf="!d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onWorkflowNotesClick(d.data)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let t of 'boardHistoryCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onBoardHistoryClick(t.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'boardNotesCellTemplate'">
                                <div *ngIf="d.data.hasBoardNotes">
                                    <i
                                        class="cc-1-5x icon-data-content cc-icon-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onBoardNotesClick(d.data)"
                                    ></i>
                                </div>
                                <div *ngIf="!d.data.hasBoardNotes">
                                    <i
                                        class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onBoardNotesClick(d.data)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let d of 'invoiceFileCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content cc-icon-pdf"
                                    [ngClass]="iconPDF"
                                    (click)="onDownloadFile(d.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'eftCellTemplate'">
                                <div *ngIf="d.data.eft">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>

                            <div *dxTemplate="let r of 'responsibleTemplate'" class="responsible-container">
                                <ng-container
                                    *ngIf="r.data.dashboardResponsibleUsers.length === 1"
                                    [ngTemplateOutlet]="singleUserTemplate"
                                    [ngTemplateOutletContext]="{
                                        data: r.data,
                                        user: r.data.dashboardResponsibleUsers[0]
                                    }"
                                ></ng-container>
                                <ng-container
                                    *ngIf="r.data.dashboardResponsibleUsers.length > 1"
                                    [ngTemplateOutlet]="multiUsersTemplate"
                                    [ngTemplateOutletContext]="{ data: r.data }"
                                ></ng-container>
                            </div>

                            <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                                {{ header.column.caption }}
                                <app-security-info
                                    securityIndicator="LOCK"
                                    apiAction="GET"
                                    apiUrl="api/wf/vendoredit/queue"
                                ></app-security-info>
                            </div>

                            <div *dxTemplate="let row of 'workflowStatusCellTemplate'">
                                <app-workflow-status-link
                                    *ngIf="row.data.workflowStatus"
                                    [status]="row.data.workflowStatus"
                                ></app-workflow-status-link>
                            </div>

                            <dxo-summary>
                                <dxi-group-item
                                    column="workflowId"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="data.communityId"></app-user-bio-link>
    </div>
</ng-template>

<ng-template #multiUsersTemplate let-data="data">
    <app-hyperlink-creator
        cssCass="cc-hyperlink-hover"
        [displayText]="data.responsibleUsers"
        (onLinkClick)="showUsersList(data)"
    ></app-hyperlink-creator>
</ng-template>

<dx-popup
    *ngIf="!!selectedWorkflowVendorEditRow"
    [title]="'Responsible Users for #' + selectedWorkflowVendorEditRow?.workflowId"
    width="20%"
    height="60%"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="showUsersListPopup"
    (onHidden)="selectedWorkflowVendorEditRow = null"
>
    <div *dxTemplate="let data of 'content'">
        <dx-list
            selectionMode="none"
            pageLoadMode="scrollBottom"
            noDataText="No Responsible Users"
            searchExpr="displayName"
            [dataSource]="selectedWorkflowVendorEditRow.dashboardResponsibleUsers"
            [searchEnabled]="true"
            [focusStateEnabled]="false"
            [activeStateEnabled]="false"
            [hoverStateEnabled]="false"
        >
            <div *dxTemplate="let user of 'item'" class="responsibleusers-listitem">
                <app-user-bio-link
                    [user]="user"
                    [communityId]="selectedWorkflowVendorEditRow.communityId"
                ></app-user-bio-link>
            </div>
        </dx-list>
    </div>
</dx-popup>

<app-lite-mode-preference
    #liteModePreference
    [defaultMode]="true"
    [storageKey]="'MANAGE_WORKFLOW_VENDOR_EDIT'"
    [pageName]="'Manage AAP Workflow Vendor Edit'"
    (onLoad)="setStoredLiteMode($event)"
    (onChanged)="onLiteModePreferenceChange()"
></app-lite-mode-preference>

<app-workflow-notes-editor
    *ngIf="showWorkFlowNotesPopUp"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    [communityId]="selectedWorkflowVendorEditRow.communityId"
    [hasNotes]="selectedWorkflowVendorEditRow.hasNotes"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showWorkFlowHistoryPopUp"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    [communityId]="selectedWorkflowVendorEditRow.communityId"
    (onClose)="onWorkflowHistoryClose()"
></app-workflow-history>

<app-workflow-board-history
    *ngIf="showWorkFlowBoardHistoryPopUp"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    [communityId]="selectedWorkflowVendorEditRow.communityId"
    (onClose)="onWorkflowBoardHistoryClose()"
></app-workflow-board-history>

<app-workflow-board-notes-editor
    *ngIf="showWorkFlowBoardNotesPopUp"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    [communityId]="selectedWorkflowVendorEditRow.communityId"
    (closeNotesPopUp)="onWorkdlowBoardNotesPopClose($event)"
></app-workflow-board-notes-editor>

<app-workflow-vendor-edit-editor
    *ngIf="showWorkflowVendorEdit"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    [communityId]="selectedWorkflowVendorEditRow.communityId"
    (onCloseWorkflowVendorEditor)="onCloseWorkflowVendorEditor($event)"
></app-workflow-vendor-edit-editor>

<app-workflow-delete
    *ngIf="showDeleteWorkflowPopUp"
    [workflowId]="selectedWorkflowVendorEditRow.workflowId"
    (onDeleteWorkflow)="onDeleteWorkflow($event)"
    (onClose)="onDeleteWorkflowClose()"
></app-workflow-delete>

<dx-load-panel
    [position]="{ of: '#workflowVendorEditBox' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
